import React from 'react';

const DonorsFloatingBtn = ({ onNavigate }) => {
  return (
    <div className="sticky-donors-btn" onClick={() => onNavigate('dathalu')}>
      <div className="cta-content">
        <span className="cta-icon">🙏</span>
        <span className="cta-text">దాతల వివరాలు</span>
      </div>
    </div>
  );
};

export default DonorsFloatingBtn;
